import React from "react";
import { MdOutlineClose } from "react-icons/md";
import NewButton from "../../../components/Button/NewButton";

const AddUpdateICO = ({
  handleSubmit,
  handleInputChange,
  isModalOpen,
  errors,
  form,
  closeModal,
  isLoading,
}) => {
  return (
    <div>
      {isModalOpen && (
        <div className="fixed inset-0 z-40 flex items-center justify-center backdrop-blur-sm bg-black bg-opacity-70">
          <div className="bg-white p-6 rounded-xl shadow-lg md:w-[500px] w-[95%] max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold text-gray-800">
                {form?.id ? "Edit ICO Management" : "Add ICO Management"}
              </h2>
              <button
                onClick={closeModal}
                className="p-1 rounded-full hover:bg-gray-100 transition-colors duration-200"
                aria-label="Close modal"
              >
                <MdOutlineClose size={24} className="text-gray-600" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Title Section Comment for now  */}
              {/* <div className='space-y-2'>
                <label className='block text-sm font-medium text-gray-700'>
                  Name <span className='text-red-500'>*</span>
                </label>
                <input
                disabled={true}
                  type='text'
                  name='name'
                  value={form?.name || ''}
                  onChange={handleInputChange}
                  placeholder='Enter name...'
                  className={`w-full px-3 py-2 border ${errors.heading ? 'border-red-500' : 'border-gray-300'} rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500`}
                />
                {errors?.name && (
                  <p className='mt-1 text-sm text-red-600'>{errors.name}</p>
                )}
              </div> */}

              {/* Description Section comment for now */}
              {/* <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  Description <span className="text-red-500">*</span>
                </label>
                <textarea
                  disabled={true}
                  name="description"
                  value={form?.description || ""}
                  onChange={handleInputChange}
                  placeholder="Enter description..."
                  rows={4}
                  className={`w-full px-3 py-2 border ${
                    errors.description ? "border-red-500" : "border-gray-300"
                  } rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500`}
                />
                {errors?.description && (
                  <p className="mt-1 text-sm text-red-600">
                    {errors.description}
                  </p>
                )}
              </div> */}

              {/* Media Upload Section */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Start Date */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    ICO Start Date <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="datetime-local"
                    name="startDate"
                    value={form?.startDate || ""}
                    onChange={handleInputChange}
                    className={`w-full px-3 py-2 border ${
                      errors.startDate ? "border-red-500" : "border-gray-300"
                    } rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  />
                  {errors?.startDate && (
                    <p className="mt-1 text-sm text-red-600">
                      {errors.startDate}
                    </p>
                  )}
                </div>

                {/* End Date */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    ICO End Date <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="datetime-local"
                    name="endDate"
                    value={form?.endDate || ""}
                    onChange={handleInputChange}
                    className={`w-full px-3 py-2 border ${
                      errors.endDate ? "border-red-500" : "border-gray-300"
                    } rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  />
                  {errors?.endDate && (
                    <p className="mt-1 text-sm text-red-600">
                      {errors.endDate}
                    </p>
                  )}
                </div>
              </div>

              {/* Submit Button */}
              <div className="pt-2">
                <NewButton
                  type="submit"
                  disabled={isLoading}
                  className="w-full justify-center"
                >
                  {isLoading
                    ? "Processing..."
                    : form?.id
                    ? "Update ICO Management"
                    : "Add ICO Management"}
                </NewButton>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddUpdateICO;
